export { default } from './I18nManager';
